import { useEffect, useState } from 'react';
import { compareVersions, getVersionHistory, type VersionDiff } from '../services/version.service';
import type { ProcessBlueprintVersion } from '../../../types/processBlueprint';

interface UseVersionCompareOptions {
  enabled?: boolean;
  reloadKey?: number;
}

export function useVersionCompare(blueprintId: string | null, organizationId: string, options: UseVersionCompareOptions = {}) {
  const { enabled = true, reloadKey = 0 } = options;
  const [versions, setVersions] = useState<ProcessBlueprintVersion[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | undefined>();
  const [diff, setDiff] = useState<VersionDiff | null>(null);

  useEffect(() => {
    if (!blueprintId || !enabled) return;
    let cancelled = false;
    setLoading(true);
    setError(undefined);
    setVersions([]);
    setDiff(null);
    getVersionHistory(blueprintId, organizationId)
      .then((data) => {
        if (cancelled) return;
        setVersions(data);
        if (data.length >= 2) {
          setDiff(compareVersions(data[1].payload as Record<string, unknown>, data[0].payload as Record<string, unknown>));
        } else {
          setDiff(null);
        }
      })
      .catch((err: Error) => {
        if (cancelled) return;
        setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [blueprintId, organizationId, enabled, reloadKey]);

  return { versions, diff, loading, error };
}
